import { useEffect, useState } from 'react';

const getRemaining = (deadlineMs) => Math.max(0, deadlineMs - Date.now());

// Ticks once per second, aligned to the wall-clock second so the display never skips.
const useCountdown = (deadline) => {
	const deadlineMs = deadline.getTime();
	const [remainingMs, setRemainingMs] = useState(() => getRemaining(deadlineMs));

	useEffect(() => {
		let timeoutId;

		const tick = () => {
			const remaining = getRemaining(deadlineMs);
			setRemainingMs(remaining);
			if (remaining > 0) {
				timeoutId = setTimeout(tick, 1000 - (Date.now() % 1000));
			}
		};

		tick();
		return () => clearTimeout(timeoutId);
	}, [deadlineMs]);

	const totalSeconds = Math.floor(remainingMs / 1000);

	return {
		days: Math.floor(totalSeconds / 86400),
		hours: Math.floor((totalSeconds % 86400) / 3600),
		minutes: Math.floor((totalSeconds % 3600) / 60),
		seconds: totalSeconds % 60,
		totalHours: Math.floor(totalSeconds / 3600),
		totalMinutes: Math.floor(totalSeconds / 60)
	};
};

export default useCountdown;
